import React from "react";
import BaseLayout from "../../layout/base/BaseLayout";
import { graphql } from "gatsby";
import { Box, Stack } from "@mui/material";
import Bg from "../../images/blog-bg.png";
import BlogImg from "../../images/blog.png";
import SearchWidget from "./search/SearchWidget";
import Header from "./Header";
import { get, map } from "lodash";
import Post from "./post/Post";
import Sidebar from "./Sidebar";
import Pagination from "./Pagination";
import Seo from "../../components/Seo";
import QueryPreservingLink from "../../components/QueryPreservingLink";

const Blog = ({
  pageContext,
  data: {
    prismicPage: {
      data: { body },
    },
  },
}) => {
  const {
    group: posts,
    category: postsCategory,
    author: postsAuthor,
    tag: postsTag,
    ...sidebarContext
  } = pageContext;

  const headerProps = {
    postsCategory,
    postsAuthor,
    postsTag,
  };

  const { section_title, section_cta_text, section_footer } = body[0]?.primary;

  return (
    <BaseLayout>
      <Stack
        sx={{
          alignItems: "center",
          marginTop: "60px",
          padding: { xs: "0 24px", md: "0 60px" },
          position: "relative",
        }}
      >
        <Stack
          sx={{
            maxWidth: "1240px",
            width: "100%",
          }}
        >
          <Stack
            direction="row"
            sx={{
              padding: "30px 18px",
              height: "280px",
              background: `url("${Bg}") #f4f4f4`,
              backgroundSize: "cover",
              position: "relative",
              borderRadius: "30px",
            }}
          >
            <Box
              sx={{
                flex: 1,
                backgroundImage: `url("${BlogImg}")`,
                backgroundPosition: `center`,
                backgroundSize: `contain`,
                backgroundRepeat: "no-repeat",
                display: { xs: "none", sm: "block" },
              }}
            />

            <Stack sx={{ flex: 1 }}>
              <Stack
                sx={{
                  maxWidth: "360px",
                }}
              >
                <Box
                  component={QueryPreservingLink}
                  to="/blog"
                  sx={{
                    textDecoration: "none",
                    fontSize: { xs: "32px", sm: "48px" },
                    fontWeight: 900,
                    color: "#6a27e8",
                    marginBottom: "17px",
                  }}
                >
                  {section_title.text}
                </Box>

                <SearchWidget title={section_cta_text.text} />
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              padding: "42.8px 0 60.3px",
            }}
          >
            <Header {...headerProps} title={section_footer.text} />

            <Stack
              direction={{ xs: "column", lg: "row" }}
              sx={{
                marginTop: "26.2px",
                alignItems: { xs: "stretch", lg: "start" },
              }}
            >
              <Stack
                sx={{
                  flexGrow: 1,
                }}
              >
                {map(posts, ({ node: { id, ...postProps } }) => (
                  <Stack
                    key={`post-${id}`}
                    sx={{
                      marginBottom: "26.1px",
                      marginRight: { xs: 0, lg: "40px" },
                      flexGrow: 1,
                    }}
                  >
                    <Post {...postProps} id={id} />
                  </Stack>
                ))}
              </Stack>

              <Box component={Sidebar} {...sidebarContext} />
            </Stack>

            <Box
              sx={{
                alignSelf: "center",
                mt: "40px",
              }}
              component={Pagination}
              {...pageContext}
            />
          </Stack>
        </Stack>
      </Stack>
    </BaseLayout>
  );
};

export const pageQuery = graphql`
  {
    prismicPage(uid: { eq: "page.blog" }, lang: { eq: "en-gb" }) {
      data {
        meta {
          document {
            __typename
            ... on PrismicMetadata {
              data {
                title
                body {
                  __typename
                  ... on PrismicMetadataDataBodyLink {
                    slice_type
                    items {
                      key
                      type
                      link {
                        url
                      }
                    }
                  }
                  ... on PrismicMetadataDataBodyText {
                    slice_type
                    items {
                      key
                      text
                      type
                    }
                  }
                }
              }
            }
          }
        }
        body {
          __typename
          ... on PrismicPageDataBodySection {
            primary {
              section_title {
                html
                text
              }
              section_image {
                alt
                copyright
                url
              }
              section_cta_text {
                html
                text
              }
              section_footer {
                html
                text
              }
            }
          }
        }
      }
    }
  }
`;

export const Head = (queryResult) => {
  const meta = get(queryResult, ["data", "prismicPage", "data", "meta"], {});

  return <Seo meta={meta} />;
};

export default Blog;
